// Generated by scripts/build-ui-icons.mjs.
export { Smiley as default } from "../ui/glyphs-7";
